import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  FooterLink,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";
import { AssetImg } from "../../common/AssetImg";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Para>
                {t(`Do you have any question with web?`)}
              </Para>
              <a href="mailto:sjorquerac@intercosplay.cl">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Bases")}</Title>
              {/**<FooterLink target="_blank" href="/pdf/bases_food_2026.pdf">{t("Bases foodtruck & foodstand")}</FooterLink>*/}
              <FooterLink target="_blank" href="/pdf/bases_pasarela_2026.pdf">{t("Catwalk Bases")}</FooterLink>
              <FooterLink target="_blank" href="/pdf/bases_prensa_y_fotografia_2026.pdf">{t("Bases Journalist & Photography")}</FooterLink>
              <FooterLink target="_blank" href="/pdf/bases_ycc_chile_2026.pdf">{t("Bases Yamato Cosplay Cup")}</FooterLink>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{t("Produces")}</Title>
              <FooterLink target="_blank" href="https://www.instagram.com/ketsuenproducciones">{t("Ketsuen Producciones")}</FooterLink>
              <Title>{t("Organize")}</Title>
              <FooterLink target="_blank" href="https://www.instagram.com/katsuracosplay">{t("Katsura Cosplay")}</FooterLink>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("When & Where")}</Language>
              <Para>Centro Cultural Chimkowe, Peñalolén</Para>
              <Para>Avenida Grecia <span className="no-bubbleboddy">8787</span></Para>
              <Para>Santiago</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Empty />
              <Title>{t("Forms")}</Title>
              <FooterLink target="_blank" href="https://forms.gle/vdzLnajSxh8EB76Z7">{t("Catwalk Form")}</FooterLink>
              {/*<FooterLink target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSec-kOUQxVaKgCOUQqAWWrRIaiX2EXs9-y8xE5RGTzgLiak4Q/viewform">{t("Double Cosplay Form")}</FooterLink>*/}
              <FooterLink target="_blank" href="https://forms.gle/KaWW7ifRm4mESLsx8">{t("Entrepreneur Stand Form")}</FooterLink>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Empty />
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="chile.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <AssetImg srcSet={{ 
                  small: {size: "141w", path: "logo_color_small.png"},
                  medium: {size: "100px", path: "logo_color_medium.png"},
                  large: {size: "352w", path: "logo_color_medium.png"},
                }} type="png"/>
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://www.instagram.com/intercosplaychile"
                src="instagram.svg"
              />
              <SocialLink
                href="https://www.instagram.com/ketsuenproducciones"
                src="facebook.svg"
              />
              <SocialLink
                href="https://www.ecopass.cl/events/intercosplay-chile-2026/17652?"
                src="ticket.svg"
              />
              {/*
                <a
                href="https://ko-fi.com/Y8Y7H8BNJ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="Buy Me a Coffee at ko-fi.com"
                />
              </a>
              */}
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
